import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

// API
import * as API  from '../../utils/api'

// Components
import SchoolSearchAutocompleteInput from '../../components/Global/Forms/SchoolSearchAutocompleteInput'
import SelectFormInput from '../../components/Global/Forms/SelectFormInput'
import Select from 'react-select'
import 'react-select/dist/react-select.css'

// Utilities
import stateNamesOptions from '../../utils/data/stateNames.json'

class CoachSearchForm extends Component {

  state = {
    input: {
      college: '',
      college_name: '',
      gender: '',
      sport: '',
      division: '',
      conference: '',
      states: []
    },
    formErrors: {
      college: '',
      gender: '',
      sport: '',
      division: '',
      conference: '',
      states: ''
    },
    options: {
      gender: [
        { value: 'M', label: 'Men\'s' },
        { value: 'W', label: 'Women\'s' },
        { value: 'C', label: 'Coed' }
      ],
      sportOptions: [],
      conferenceOptions: [],
      divisionOptions: [],
      stateOptions: []
    },
    submission: {},
    results: null,
    displayErrorMessages: false,
    formIsValid: false,
    isLoading: true,
    searching: false,
    status: '',
    disabled: false,
  }

  componentDidMount() {
    const { user } = this.props
    this.setSubscriptionStateBasedOnRedux(user)
  }

  setSubscriptionStateBasedOnRedux(user) {
    API.getCollegeSportsDivsConfs(user).then(response => {
      this.setState({ isLoading: false })
      if (response.errors) {
        this.setState({ disabled: true })
      } else {
        this.prepopulateForm(response)
      }
    })
  }

  prepopulateForm(data) {
    this.setState(state => ({
      ...state,
      input: {
        ...state.input,
      },
      options: {
        ...state.options,
        sportOptions: this.getCollegeOptions(data, "sports"),
        divisionOptions: this.getCollegeOptions(data, "divisions"),
        conferenceOptions: this.getCollegeOptions(data, "conferences"),
        stateOptions: stateNamesOptions
      },
      isLoading: false
    }))
  }

  getCollegeOptions(data, type) {
    let options = data[type].map((item) => {
      return { value: item, label: item }
    })

    return options
  }

  handleSchoolSelection = (school) => {
    let school_id = school.id
    this.setState(state => ({
      ...state,
      searching: false,
      input: {
        ...state.input,
        college: school_id,
        college_name: school.name
      }
    }))
  }

  handleMultiSelectChange = selectedOptions => {
    this.setState(state => ({
      ...state,
      assignStatesValue: selectedOptions,
      input: {
        ...state.input,
        states: selectedOptions.map( state => state.value )
      }
    }))
  }

  handleInputChange = (event) => {
    const { value, name } = event.target

    this.setState(state => ({
      ...state,
      input: {
        ...state.input,
        [name]: value
      }
    }), () => { this.updateFieldErrorMessage(name, value) })
  }

  updateFieldErrorMessage = (fieldName, value) => {
    let formErrors = this.state.formErrors
    switch(fieldName) {
      case 'gender':
        formErrors.gender = value.length > 0
          ? ''
          : 'Please select a gender'
          // eslint-disable-next-line no-unreachable
        break
      case 'sport':
        formErrors.sport = value.length > 0
          ? ''
          : 'Please select a sport'
          // eslint-disable-next-line no-unreachable
        break
      case 'college':
      case 'college_name' :
      case 'division':
      case 'conference':
      case 'states':
        formErrors[fieldName] = ''
        // eslint-disable-next-line no-unreachable
        break
      default:
        formErrors[fieldName] = value !== ''
          ? ''
          : 'Please complete this field'
          // eslint-disable-next-line no-unreachable
        break
    }

    this.setState(state => ({
      ...state,
      formErrors,
    }))
  }

  toggleErrorMessages() {
    const { displayErrorMessages } = this.state

    this.setState(state => ({
      ...state,
      displayErrorMessages: !displayErrorMessages
    }))
  }

  setFormErrorState = () => {
    const { input, displayErrorMessages } = this.state

    Object.keys(input).map((field, i) => {
      return this.updateFieldErrorMessage(field, input[field])
    })

    if (!this.state.formIsValid && !displayErrorMessages) {
      this.toggleErrorMessages()
    }
  }

  isFormValid() {
    const {
      input,
    } = this.state

    let inputErrorIndex = Object.keys(input).map((field, i) => {
      if (field === 'college') {
        return true
      } else if (field === 'division') {
        return true
      } else if (field === 'states') {
        return true
      } else {
        return this.isFieldValid(field, input[field])
      }
    }).indexOf(false)

    if (inputErrorIndex > -1) {
      return false
    } else {
      return true
    }
  }

  isFieldValid = (fieldName, value) => {
    switch(fieldName) {
      case 'gender':
        return value.length > 0
        // eslint-disable-next-line no-unreachable
        break
      case 'sport':
        return value.length > 0
        // eslint-disable-next-line no-unreachable
        break
      case 'college':
      case 'college_name':
      case 'division':
      case 'conference':
      case 'states':
        return true
        // eslint-disable-next-line no-unreachable
        break
      default:
        return value ? true : false
        // eslint-disable-next-line no-unreachable
        break
    }
  }

  handleSubmit = (event) => {
    event.preventDefault()
    const { user } = this.props
    const { input } = this.state

    if (this.isFormValid()) {

      let submission = {
        college: input.college,
        college_name: input.college_name,
        gender: input.gender,
        sport: encodeURIComponent(input.sport),
        division: input.division,
        conference: input.conference,
        states: input.states
      }

      this.setState({
        status: 'submitting'
      },
        () => API.getCollegeCoaches(user, submission).then(results => {
          this.setState({ submission: submission, results: results })
        })
      )
    } else {
      this.setFormErrorState()
    }
  }

  render() {
    const {
      input,
      formErrors,
      displayErrorMessages,
      options,
      submission,
      results,
      status,
      disabled,
    } = this.state

    const { submitButtonText } = this.props

    if (results) {
      return (
        <Redirect to={{pathname: "/colleges/coaches", state: {...results, submission}}} />
      )
    }
    return (
      <section className="coach-search-container">
        <h2>Search for a College Coach</h2>
        { disabled
          ? (
            <div>
              College Coach search is currently unavailable. Please <a href="https://lockerlinked.com/feedback" rel="noopener noreferrer" target="_blank">contact us</a> if this error persists.
            </div>
          )
          : (
            <div>
              <form
                onSubmit={this.handleSubmit}
                className="coach-search-form"
              >
                <SchoolSearchAutocompleteInput
                  schoolSearchType='college'
                  onChange={(selectedSchool) => this.handleSchoolSelection(selectedSchool)}
                  showError={displayErrorMessages}
                  errorMessage={formErrors.college}
                />
                <SelectFormInput
                  label='Gender*'
                  name='gender'
                  placeholder="Please Select"
                  value={input.gender}
                  onChange={this.handleInputChange}
                  errorMessage={formErrors.gender}
                  showError={displayErrorMessages}
                  selectOptions={options.gender}
                />
                <SelectFormInput
                  label='Sport*'
                  name='sport'
                  placeholder="Please Select"
                  value={input.sport}
                  onChange={this.handleInputChange}
                  errorMessage={formErrors.sport}
                  showError={displayErrorMessages}
                  selectOptions={options.sportOptions}
                />
                <SelectFormInput
                  label='Division'
                  name='division'
                  placeholder='Any'
                  value={input.division}
                  onChange={this.handleInputChange}
                  errorMessage={formErrors.division}
                  selectOptions={options.divisionOptions}
                />
                <SelectFormInput
                  label='Conference'
                  name='conference'
                  placeholder="Any"
                  value={input.conference}
                  onChange={this.handleInputChange}
                  errorMessage={formErrors.conference}
                  selectOptions={options.conferenceOptions}
                />
                <label>State</label>
                <Select
                  className="input-container select-container"
                  name="states[]"
                  multi={true}
                  placeholder="Select (Optional)"
                  value={this.state && this.state.assignStatesValue}
                  onChange={(...selectedOptions) => this.handleMultiSelectChange(...selectedOptions)}
                  options={options.stateOptions}
                />
                {
                  status === 'submitting'
                  ? (
                    <div className="spinner"></div>
                  )
                  : (
                    <input
                      type="submit"
                      className="cta-gradient"
                      value={submitButtonText ? submitButtonText : 'Submit'}
                      onClick={this.handleSubmit}
                    />
                  )
                }
              </form>

              <div>
                <p class="note"><strong>Please Note:</strong> COVID-19 has impacted college athletic budgets and has caused colleges to eliminate various sports, thus it is important to verify the sport as still active by visiting the official athletic site of the specific college program of interest.</p>
              </div>
            </div>
          )
        }
      </section>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.user
  }
}

export default connect(
  mapStateToProps,
  null
)(CoachSearchForm)



// WEBPACK FOOTER //
// ./src/components/CoachSearch/CoachSearchForm.js